import styled, { css } from 'styled-components';

import { isFocused, isHovered } from 'design-system/lib/pseudoClass';
import { focusMixin } from 'design-system/mixins/hoverable';
import PseudoClassProps from 'design-system/types/PseudoClassProps';
import { TransitionDuration } from 'design-system/variables/transitions';

interface TableRowProps extends PseudoClassProps {
  disableHoverBackground?: boolean;
}

const TableRow = styled.tr.attrs({
  role: 'row',
})<TableRowProps>`
  display: table-row;

  ${({ onClick }) =>
    onClick != null &&
    css`
      cursor: pointer;
    `}

  ${({ disableHoverBackground, theme }) =>
    !disableHoverBackground &&
    css`
      &${isHovered} {
        background-color: ${theme.color.background.highlight};
        transition-duration: ${TransitionDuration.Fast};
      }
    `}

  &${isFocused} {
    ${focusMixin()}
  }
`;

export default TableRow;
